<div class="rule-list">
	<div *ngFor="let rule of rules" class="rule-item" [ngClass]="{'fixed-rule': rule.isFixed}" [title]="rule.description">
		<div>{{rule.code}}</div>
		<i class="glyphicons" [ngClass]="{'glyphicons-ok': rule.isFixed, 'glyphicons-remove': !rule.isFixed}"></i>
	</div>
</div>